<template>
  <div class="fps-video" :style="{ borderRadius }" @mousemove="moveInVideo">
    <div
      ref="video_wrap"
      class="fps-video-wrap"
      :class="scaleVideo && 'fps-video-scale'"
    >
      <video
        ref="fps_video"
        :src="src"
        class="fps-video-content"
        :class="position + (longWidth ? '-width' : '-height')"
        @loadedmetadata="loadVideo"
        @ended="play = false"
        @pause="play = false"
      >
        您的瀏覽器暫不支持視頻播放
      </video>
      <div v-show="isLoading" class="loading-wrap">
        <i class="el-icon-loading"></i>
      </div>
      <fps-icon v-show="!isLoading && showPauseBtn" class="play-icon play-stop pointer" type="stop" size="40" @click.native.stop="pauseVideo" />
      <fps-icon v-show="!isLoading && !play" class="play-icon pointer" type="play" size="40" @click.native.stop="playVideo" />
      <div class="footer-buttons">
        <fps-icon v-show="scaleVideo" class="tool-icon" type="sf" @click.native.stop="scaleVideo = false" />
        <fps-icon v-show="!scaleVideo" class="tool-icon scale-big" type="fd" @click.native.stop="scaleVideo = true" />
      </div>
    </div>
  </div>
</template>
<script>
const videoController = {
  playingVideo: null,
  videoMap: {},
  nextId: 0,
}
export default {
  props: {
    src: {
      type: String,
      require: true,
    },
    borderRadius: {
      type: String,
      default: '12px',
    },
    longWidth: {
      type: Boolean,
      default: true,
    },
    // cover || contain
    position: {
      type: String,
      default: 'contain',
    },
  },
  data() {
    return {
      play: false,
      isLoading: true,
      scaleVideo: false,
      showPauseBtn: false,
    }
  },
  watch: {
    src() {
      this.isLoading = true
      this.play = false
    },
    scaleVideo(flag) {
      if (flag) document.body.style.overflow = 'hidden'
      else document.body.style.overflow = 'auto'
    },
    play(play) {
      // 監聽滾動，取消播放
      if (play) {
        document.addEventListener('scroll', this.scrollPause)
      } else {
        document.removeEventListener('scroll', this.scrollPause)
      }
    }
  },
  mounted() {
    this.video = this.$refs.fps_video
    if (this.video) {
      videoController.nextId++
      this.videoMap = {
        id: videoController.nextId,
        dom: this.video
      }
      videoController.videoMap = this.videoMap
    }
  },
  beforeDestroy() {
    delete videoController.videoMap[this.videoMap.id]
    if (this.pauseBtnTimer) clearTimeout(this.pauseBtnTimer)
  },
  methods: {
    scrollPause() {
      if (!this.play) return
      const dom = this.$refs.video_wrap
      if (dom) {
        const domSize = dom.getBoundingClientRect()
        console.log(domSize.y, screen.height, domSize.height, screen.height - domSize.height / 3)
        if (domSize.y < domSize.height * -2 / 3 || domSize.y > screen.height - domSize.height / 3) {
          this.pauseVideo()
        }
      }
    },
    moveInVideo() {
      if (this.play) {
        this.showPauseBtn = true
        if (this.pauseBtnTimer) clearTimeout(this.pauseBtnTimer)
        this.pauseBtnTimer = setTimeout(() => {
          this.showPauseBtn = false
          this.pauseBtnTimer = null
        }, 1000)
      }
    },
    loadVideo() {
      this.isLoading = false
    },
    pauseVideo() {
      this.video.pause()
      videoController.playingVideo = null
      this.showPauseBtn = false
      this.play = false
    },
    playVideo() {
      if (videoController.playingVideo) videoController.playingVideo.pause()
      videoController.playingVideo = this.video
      this.moveInVideo()
      this.video.play()
      this.play = true
    },
  }
}
</script>
<style lang="scss">
  .fps-video {
    width: 100%;
    height: 100%;
    background: #000;
    overflow: hidden;
    @include flex;
  }
  .video-bottom {
    height: 1px;
  }
  .fps-video-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .loading-wrap,
    .play-icon {
      font-size: 40px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
    }
    .play-stop {
      transform: scale(0) translate(-50%, -50%);
    }
    .footer-buttons {
      position: absolute;
      bottom: 13px;
      right: 13px;
      @include flex(flex-end);
      .tool-icon {
        font-size: 28px;
        color: #fff;
        opacity: 0;
        cursor: pointer;
      }
      .scale-big {
        transform: rotate(90deg);
      }
    }
    &:hover {
      .play-stop {
        transform: scale(1) translate(-50%, -50%);
      }
      .tool-icon {
        opacity: 1;
      }
    }
    .fps-video-content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      &.cover-width,
      &.contain-height {
        height: 100%;
      }
      &.contain-width,
      &.cover-height {
        width: 100%;
      }
    }
    &.fps-video-scale {
      position: fixed;
      z-index: 5555;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, .9);
      @include flex;
      .fps-video-content {
        position: static;
        transform: scale(1);
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>
